// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e88af739","453":"d060b79d","455":"1dad5916","977":"af15084b"}[chunkId] + ".chunk.js";
};